export default "__VITE_ASSET__BkZ0w6PX__"